var _defs, _g, _ellipse, _polygon, _path, _path2, _polygon2, _path3, _path4, _path5, _path6, _polygon3, _path7, _path8, _path9, _polygon4, _polygon5, _path10, _polygon6, _polygon7, _path11, _path12, _polygon8, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation387(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0010_presentation",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    "data-imageid": "presentation-3-87",
    imageName: "Presentation 3",
    className: "illustrations_image",
    style: {
      width: 188
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1_presentation-3-87,.cls-2_presentation-3-87{fill:#fff;}.cls-3_presentation-3-87{fill:#f4a28c;}.cls-4_presentation-3-87{fill:#a5a5a5;}.cls-5_presentation-3-87{opacity:.03;}.cls-5_presentation-3-87,.cls-6_presentation-3-87,.cls-7_presentation-3-87{fill:#000001;}.cls-8_presentation-3-87{fill:#e6e6e6;}.cls-9_presentation-3-87{fill:#ce8172;opacity:.31;}.cls-10_presentation-3-87{opacity:.58;}.cls-10_presentation-3-87,.cls-11_presentation-3-87,.cls-12_presentation-3-87{fill:#F86624;}.cls-2_presentation-3-87{opacity:.2;}.cls-13_presentation-3-87{fill:#24285b;}.cls-6_presentation-3-87{opacity:.08;}.cls-11_presentation-3-87{opacity:.73;}.cls-7_presentation-3-87{opacity:.1;}.cls-14_presentation-3-87{fill:#ffd200;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "screen_presentation-3-87"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8_presentation-3-87",
    x: 119.36,
    y: 67.77,
    width: 314.65,
    height: 252.02
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4_presentation-3-87",
    points: "388.06 256.56 189.83 256.56 189.83 94.78 194.99 94.78 194.99 251.41 388.06 251.41 388.06 256.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7_presentation-3-87",
    d: "m208.52,221.58l-4.71-2.09c.56-1.26,13.84-30.91,29.8-44.83,17.65-15.39,36.16-.69,53.54,17.49,4.52,4.73,10.13,6.24,16.67,4.47,13.45-3.63,26.8-20.05,29.74-32.31,4.29-17.88,19.11-55.86,37.52-59.17l.91,5.08c-13.55,2.43-28.36,34.24-33.42,55.3-3.29,13.69-17.82,31.88-33.41,36.09-8.39,2.26-15.9.22-21.74-5.89-18.03-18.87-32.83-29.02-46.42-17.17-15.1,13.16-28.34,42.74-28.48,43.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7_presentation-3-87",
    d: "m138.76,107.89s31.82,9.7,19.35,29.19c-12.47,19.49-8.62,40.06-8.62,40.06,0,0,70.73-13.83,69.29,56.9l27.76-5.25,22.5-24.11,22.85-37.8,6.75,3.7-37.49,80.52-10.76-6.31s-10.94,52.09-34.23,74.98h-96.8l-.8-61.83.8-103.71,19.41-46.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_presentation-3-87",
    x: 119.36,
    y: 45.89,
    width: 314.65,
    height: 21.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4_presentation-3-87",
    d: "m260.4,349.86v-30.07h-5.16v30.07c-5.33,1.18-9.34,5.94-9.34,11.63,0,6.57,5.35,11.92,11.92,11.92s11.92-5.35,11.92-11.92c0-5.69-4-10.45-9.34-11.63Zm-2.58,18.39c-3.73,0-6.76-3.03-6.76-6.76s3.03-6.76,6.76-6.76,6.76,3.03,6.76,6.76-3.03,6.76-6.76,6.76Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7_presentation-3-87",
    x: 281.04,
    y: 272.34,
    width: 107.02,
    height: 25.8,
    rx: 7.08,
    ry: 7.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4_presentation-3-87",
    x: 212.4,
    y: 272.34,
    width: 50.78,
    height: 25.8,
    rx: 7.08,
    ry: 7.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13_presentation-3-87",
    cx: 331.35,
    cy: 174.87,
    r: 7.99
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "sd_presentation-3-87",
    className: "cls-5_presentation-3-87",
    cx: 250.74,
    cy: 428.68,
    rx: 229.15,
    ry: 25.42
  })), /*#__PURE__*/React.createElement("g", {
    id: "plant_presentation-3-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10_presentation-3-87 targetColor",
    d: "m426.87,400.91s-19.84-5.33-24.23-23.76c0,0,30.69-6.34,31.69,25.36l-7.46-1.6Z",
    style: {
      fill: "#F86624)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11_presentation-3-87 targetColor",
    d: "m429.29,398.94s-13.94-21.84-1.84-42.36c0,0,23.41,14.73,13.15,42.36h-11.32Z",
    style: {
      fill: "#F86624)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12_presentation-3-87 targetColor",
    d: "m432.86,398.94s7.22-23.15,29.32-27.62c0,0,4.21,15-14.21,27.62h-15.11Z",
    style: {
      fill: "#F86624)"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13_presentation-3-87",
    points: "418.48 398.48 422.61 425.95 447.92 425.95 451.54 398.48 418.48 398.48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "person_presentation-3-87"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12_presentation-3-87 targetColor",
    d: "m142.81,166.88s38.9,9.52,53.11,84.24l48.65-36.31,9.92,11.74-56.66,59.29c-5.6,5.86-14.89,6.09-20.78.51l-33.9-32.16-.34-87.31Z",
    style: {
      fill: "#F86624)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_presentation-3-87",
    d: "m142.81,166.88s38.9,9.52,53.11,84.24l48.65-36.31,9.92,11.74-56.66,59.29c-5.6,5.86-14.89,6.09-20.78.51l-33.9-32.16-.34-87.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_presentation-3-87",
    d: "m139.11,120.15s1.05,12.13-.99,20.2c-.83,3.27-4.21,5.28-7.47,4.41-4.05-1.09-9.21-3.73-10.56-10.16l-3.64-10.64s-2.05-6.74,4.82-11.68c6.86-4.94,17.57.45,17.84,7.87Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3_presentation-3-87",
    points: "118.27 126.77 104.39 157.35 122.46 170.76 126.06 141.99 118.27 126.77"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12_presentation-3-87 targetColor",
    d: "m117.64,156.76c-3.06-.73-6.1-1.58-9.1-2.53-13.48-4.31-54.92-14.84-66.76,14.11-14.21,34.73,28.42,140.5,28.42,140.5l72.62-6.31,17.36-91.56s14.97-40.41-42.54-54.19Z",
    style: {
      fill: "#F86624)"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_presentation-3-87",
    d: "m139.39,127.83l3.39,4.69c.84,1.16.19,2.8-1.22,3.06l-4.66.88,2.48-8.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9_presentation-3-87",
    d: "m125.96,142.8s-4.1-2.36-5.54-5.72c0,0-4.33,7.59,4.51,13.96l1.03-8.24Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_presentation-3-87",
    d: "m148.2,170.76s-34.09,6.45-42.06-17.27l17.85,4.99s13.4,3.4,24.2,12.28Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12_presentation-3-87 targetColor",
    d: "m172.62,415.81s3.2,5.74,8.78,5.3c5.59-.44,7.92,4.71,3.19,6.93-4.73,2.22-18.55-2.05-18.55-2.05l-.95-8.01,7.53-2.17Z",
    style: {
      fill: "#F86624)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12_presentation-3-87 targetColor",
    d: "m104.6,408.72s-1.13,6.47,3.49,9.65c4.62,3.18,3.19,8.65-1.88,7.4-5.07-1.25-13.13-13.27-13.13-13.27l4.31-6.82,7.21,3.05Z",
    style: {
      fill: "#F86624)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_presentation-3-87",
    d: "m77.95,170.59s14.04,19.48,8.78,62.11c-5.26,42.62,64.2,24.73,64.2,24.73l-8.12,45.08-72.62,6.31-8.89-23.97-18.03-62.52,34.68-51.75Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14_presentation-3-87",
    points: "125.96 234.38 134.7 184.14 162.85 201.92 193.8 191.71 185.22 245.56 153.83 255.64 125.96 234.38"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12_presentation-3-87 targetColor",
    d: "m46.53,160.03c-16.43,17.71-36.19,55.44-20.95,119.59,1.85,7.77,9.82,12.44,17.52,10.3l98.37-27.35-3.68-14.73-76.83,9.47s21.3-44.18,17-86.72c-1.57-15.5-20.83-21.98-31.42-10.56Z",
    style: {
      fill: "#F86624)"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6_presentation-3-87",
    d: "m128.48,219.89s11.69,17.96,24.58,18.97c12.88,1.01,30.28-4.75,32.16,6.7l-31.4,10.08-27.87-21.25,2.52-14.49Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2_presentation-3-87",
    d: "m46.53,160.03c-16.43,17.71-36.19,55.44-20.95,119.59,1.85,7.77,9.82,12.44,17.52,10.3l98.37-27.35-3.68-14.73-76.83,9.47s21.3-44.18,17-86.72c-1.57-15.5-20.83-21.98-31.42-10.56Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_presentation-3-87",
    d: "m77.07,255.32v25.16l64.39-17.91s20-1.98,24.21-11.45c4.21-9.47-14.73-15.5-27.89-3.28l-60.71,7.48Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1_presentation-3-87",
    points: "77.07 255.32 77.07 280.47 90.35 276.57 90.35 253.68 77.07 255.32"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14_presentation-3-87",
    points: "162.85 201.92 142.59 179.09 140.51 187.81 162.85 201.92"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_presentation-3-87",
    d: "m70.19,308.83l27.76,32.86c10.48,12.41,12.55,29.87,5.27,44.38l-8.85,17.63,13.57,6.94,12.43-19.92c10.54-16.89,13.57-37.4,8.37-56.61h0c-1.68-6.21-.37-12.85,3.56-17.95l10.51-13.65-72.62,6.31Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14_presentation-3-87",
    points: "162.85 201.92 188.3 184.14 188.3 193.52 162.85 201.92"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13_presentation-3-87",
    points: "250.38 232.41 291.83 158.8 294.95 160.67 257.69 236.29 250.38 232.41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_presentation-3-87",
    d: "m142.81,302.51l34.43,113.3-15.32,3.19s-23.47-67.91-46.7-100.53l27.58-15.96Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_presentation-3-87",
    d: "m206.57,243.16l14.09,18.78,33.83-35.4s14.02-.96,17.44-8.59c3.42-7.63-7.37-20.52-27.36-3.16l-38,28.36Z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1_presentation-3-87",
    points: "200.92 247.38 214.63 268.26 223.88 258.58 211.2 239.71 200.92 247.38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13_presentation-3-87",
    d: "m117.27,133.26s4.06,11.6,9.91,13.17c5.85,1.58,14.28,2.33,13.34-7.7-.59-6.23-7.69-3.97-15.98-2.28,0,0-3.9-7.78-3.23-12.71,0,0,5.29-.99,4.66-5.72,0,0,12.01,6.66,14.55,0s2.04-10.46-3.61-12.83-21.44-.79-25.39,6.31c-3.95,7.1,5.76,21.75,5.76,21.75Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3_presentation-3-87",
    d: "m118.36,131.54c.5-1.96-.08-4.11-1.64-5.38-.98-.8-2.28-1.23-3.9-.48-4.06,1.88-1.16,9.94,4.82,8.72l.72-2.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation387);
export default __webpack_public_path__ + "static/media/presentation-3-87.753d2e9591c161f3f267f0802d40d132.svg";
export { ForwardRef as ReactComponent };